<div class="customer-view">
  <hr-customer-basic
    [customer]="customer"
    (onUpdate)="onUpdate($event)"
  ></hr-customer-basic>
  <hr-customer-details [customer]="customer"></hr-customer-details>
  <hr-customer-billing [customer]="customer"></hr-customer-billing>
  <hr-customer-agents [customer]="customer"></hr-customer-agents>
  <hr-customer-legacy-contacts
    [customer]="customer"
  ></hr-customer-legacy-contacts>
  <hr-customer-events [customer]="customer"></hr-customer-events>
</div>
